'use client'

import { MultiChoiceSentenceQuestion } from '@entities/lesson'
import { langTypeSchema } from '@server/schemas'
import { clsx } from 'clsx'
import React from 'react'
import { match } from 'ts-pattern'

import { Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: MultiChoiceSentenceQuestion
  userAnswer: string[]
  userAnswerIndex: number
  masterAnswer: string[]
  masterAnswerIndex: number
  aiExplanation: string
  masterHighlight: number[]
}

export const WrongMultiChoiceSentenceToastDescription = ({
  question,
  userAnswer,
  userAnswerIndex,
  masterAnswer,
  masterAnswerIndex,
  aiExplanation,
  masterHighlight,
}: Props) => {
  const renderUserAnswerForeign = () => {
    return match(question)
      .with({ lang_type: langTypeSchema.Enum.EN }, () => (
        <React.Fragment>
          {userAnswer.map((part, index, origin) => {
            const isLastIndex = index === origin.length - 1

            return <span key={`userAnswer-${part}`}>{`${part}${isLastIndex ? '' : ' '}`}</span>
          })}
        </React.Fragment>
      ))
      .with({ lang_type: langTypeSchema.Enum.JP }, () => (
        <React.Fragment>
          {userAnswer.map((part) => {
            return part
          })}
        </React.Fragment>
      ))
      .otherwise(() => null)
  }

  const renderMasterAnswerForeign = () => {
    return match(question)
      .with({ lang_type: langTypeSchema.Enum.EN }, () => {
        return (
          <React.Fragment>
            {masterAnswer.map((part, index, origin) => (
              <span key={`masterAnswer-${part}`} className={clsx(masterHighlight.includes(index) && 'text-[#819DFF]')}>
                {part}
                {index !== origin.length - 1 ? ' ' : ''}
              </span>
            ))}
          </React.Fragment>
        )
      })
      .with({ lang_type: langTypeSchema.Enum.JP }, () => {
        return (
          <React.Fragment>
            {masterAnswer.map((part, index) => (
              <span key={`masterAnswer-${part}`} className={clsx(masterHighlight.includes(index) && 'text-[#819DFF]')}>
                {part}
              </span>
            ))}
          </React.Fragment>
        )
      })
      .otherwise(() => null)
  }

  return (
    <VStack className="gap-4">
      <VStack className="gap-0.5">
        <Typography size="h6" className="font-medium text-white">
          {renderUserAnswerForeign()}: {question.source.body.options[userAnswerIndex]}
        </Typography>
        <Typography size="h6" className="font-medium text-white">
          {renderMasterAnswerForeign()}: {question.source.body.options[masterAnswerIndex]}
        </Typography>
      </VStack>
      <Typography size="h6" className="font-medium text-gray-400">
        {aiExplanation}
      </Typography>
    </VStack>
  )
}
